import { Component, OnInit, OnDestroy } from '@angular/core';
import { PublisherService } from '../../core/services/publisher.service';
import { CacheConstant,Regex, UserProperty } from '../../core/constants/app.constant';
import { AuthService } from '../../core/services/auth.service';
import { Subscription } from 'rxjs';
import { OrderService } from '../../modules/order/order.service';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ProductsService } from '../../modules/products/products.service';
import { GoogleAnalyticsService } from '../../core/services/google-analytics.service';
import { AppConfigService } from '../../core/services/init/app-config.service';
import { DatePipe } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { PurchaseHistoryComponent } from '../../modules/products/purchase-history/purchase-history.component';
import {
  OktaRoutes,
  OrderRoutes,
  RoutePrefix,
  UserRoutes,
  TrackAndTraceRoutes,
  ProductRoutes,
  AEMRoutes
} from '../../core/constants/routes.constant';
import { AppUtilService } from '../../core/utils/app-util.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { UserService } from '../../core/services/user.service';
import { ChangeAccount } from '../../shared/models/user';
import { UserConstants } from '../../modules/user/user.constant';
import { AppCacheService } from '../../core/services/cache/app-cache.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'par-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  /***************Properties***************/
  private authSessionSubscription: Subscription = null;
  private authenticationSubscription: Subscription = null;
  private accountChangeSubscription: Subscription = null;
  private cartCountSubscription: Subscription = null;
  private userSettingsSubscription: Subscription = null;
  envProperties = this.cache.get(CacheConstant.Env_Properties);
  websiteName: string = this.envProperties.theme;
  routes: any = {
    forgotPassword: OktaRoutes.ForgotPassword,
    register: RoutePrefix.Register,
    shoppingCart: OrderRoutes.ShoppingCart,
    changeAccount: UserRoutes.ChangeAccount,
    websiteHelp: AEMRoutes.Help,
    websiteMajorHelp :AEMRoutes.Major.Help,
    changePassword:OktaRoutes.ChangePassword,
    updateSecurityQuestion: OktaRoutes.UpdateSecurityQuestion,
    changeAccountSettings:UserRoutes.WebAccountSettings,
    contactUs: RoutePrefix.ContactUs,
    creditCards: RoutePrefix.CreditCards,
    home: RoutePrefix.Home,
    myhome: RoutePrefix.MyHome,
    aboutus: AEMRoutes.AboutUs,
    majorAboutUs: AEMRoutes.MajorAboutUS,
    myaccount: AEMRoutes.MyAccount,
    shop: AEMRoutes.Shop,
    productServices: AEMRoutes.ProductServices,
    packageInsert: RoutePrefix.PackageInsert,
    harvardURL: this.envProperties.harvardUrl,
    favorites: ProductRoutes.Favorites,
    payInvoices: OrderRoutes.PayInvoice,
    watchList: ProductRoutes.WatchList,
    searchTransactionData: '/' + TrackAndTraceRoutes.SearchTransactionData,
    dscsaReporting: '/' + TrackAndTraceRoutes.DscsaReporting,
    csosOrderHistory: '/' + OrderRoutes.CsosOrderHistory,
    customerForms: AEMRoutes.CustomerForms,
    csosRegistration: this.envProperties.axWayRegisterUrl,
    quickOrder: OrderRoutes.QuickOrder,
    producthistory: ProductRoutes.ProductHistory,
    majorproductservices: AEMRoutes.MajorProductServices,
    productCatalog: ProductRoutes.ProductCatalog,
    productCatalogList:AEMRoutes.Major.ProductCatalogList,
    dispill: ProductRoutes.Dispill,
    promotions: ProductRoutes.Promotions,
    categories: ProductRoutes.Categories,
    categoryDetails: ProductRoutes.Category_Detail,
    promotionDetails: ProductRoutes.Promotions_Detail,
    subscription: ProductRoutes.Subscription,
    fullCatalog: ProductRoutes.Product_Search,
    orderHistory:OrderRoutes.OrderHistory,
    productReturn:ProductRoutes.ProductReturn,
    majorAmazon:RoutePrefix.Amazon,
    majorNews: AEMRoutes.Major.News,
  };
  authenticated = false;
  orderCount = -1;
  userDetail: any;
  defaultAccount: any;
  accountsList: ChangeAccount[] = [];
  private accountChangedSource = new Subject<boolean>();
  accountChanged$ = this.accountChangedSource.asObservable();
   promotions = [];
  hasPromotions: boolean = false;
  hasCategories: boolean;
  categories = [];

  ifDatePresent : boolean = false;
  lookerReportEffectiveDate = this.envProperties.lookerReportEffectiveDate;
  previousDate: Date;
  previousDString:string = '';
  isSubscriptionEnabled: boolean = this.envProperties.subscriptionEnabled;
  searchProduct: UntypedFormControl = new UntypedFormControl();
  productSuggestions: [];
  elasticSearchFlag: boolean = this.envProperties.elasticSearchFlag ? this.envProperties.elasticSearchFlag.toBoolean() : false;
  search = {
    type: null,
    option: null,
    operand: null,
    value: null,
    isAdvance: null
  };
  /***************Properties***************/

  /***************Constructor***************/
  constructor(
    private cache: AppCacheService,
    public dialog: MatDialog,
    private authService: AuthService,
    private userService: UserService,private router:Router,
    private productService: ProductsService,
    private gAnalytics: GoogleAnalyticsService,
    private config: AppConfigService,
    private datePipe: DatePipe
  ) {}

  ngOnInit() {
    this.authenticated = this.authService.isAuthenticated();
this.searchProduct.valueChanges.pipe(debounceTime(200)).pipe(distinctUntilChanged()).subscribe((productName: any) => {
      // productName = productName.replace(/^\s+/g,'');
      if (productName != null && productName.length > 2 && productName.indexOf(' ') === -1) {

        if (this.productSuggestions && this.productSuggestions.some((item) => item == productName)) {
          return;
        }
        this.productService.searchProductTypeForward(productName)
          .subscribe((response: any) => {
            if (!response.hasError) {
              this.productSuggestions = this.elasticSearchFlag ? response.suggestions : response;
            }
          }
          )
      } else {
        this.productSuggestions = [];
      }
    });
    this.authenticationSubscription = PublisherService.isAuthChanged$.subscribe(
      authenticated => this.onAuthenticationChange(authenticated)
    );

    this.accountChangeSubscription = PublisherService.isAccountChanged$.subscribe(
      accountChanged => this.onAccountChange(accountChanged)
    );

    this.cartCountSubscription = PublisherService.cartCountUpdated$.subscribe(
      count => this.onCartCountUpdate(count)
    );

    this.userSettingsSubscription = PublisherService.settingsChangedSource$.subscribe(
      response => this.onUserSettingsChange()
    );
    
    if (this.authenticated) {
      this.getAccounts();
      this.loadDefaultAccount();
    }
     let lookerReportDate = new Date(this.lookerReportEffectiveDate);
     const today = new Date();
     if(lookerReportDate <= today){
       this.lookerReportEffectiveDate = this.datePipe.transform( this.lookerReportEffectiveDate , 'MM/dd/yyyy');
       var temp = new Date(this.lookerReportEffectiveDate );
       temp.setDate(temp.getDate() - 1);
       this.previousDate = temp;
       this.previousDString = this.datePipe.transform(this.previousDate, 'MM/dd/yyyy');
       this.ifDatePresent = true;
    }
  }

  ngOnDestroy() {
    this.authenticationSubscription.unsubscribe();
    this.authSessionSubscription.unsubscribe();
    this.accountChangeSubscription.unsubscribe();
    this.cartCountSubscription.unsubscribe();
    this.userSettingsSubscription.unsubscribe();
  }
  /***************Constructor***************/

  /***************Component Methods***************/
  private getAccounts() {
    // let userDetailNum = this.userService.getDefaultAccount().userDetailNum;
    const userDetail = AppUtilService.cache.get(
      CacheConstant.User_Auth_Detail
    );
    let userDetailNum = userDetail.userDetailNum;

    this.userService
      .getAccounts(userDetailNum)
      .subscribe((response: any) => {
          this.accountsList = response;
      });
  }
  onSelectAccountClick(account) {
    const saveRequest = {
      buId: this.envProperties.buId,
      newShipToNum: account.shipToNum,
      newSoldToNum: account.accountNum,
      userDetailNum: this.userService.getDefaultAccount().userDetailNum
    };

    this.userService
      .saveDefaultAccount(saveRequest)
      .subscribe((response: any) => {
        if (response) {
          this.accountChangedSource.next(response);
          this.userService.updateProperty(
            UserProperty.DefaultShiptoNum,
            saveRequest.newShipToNum
          );

          this.userService.updateProperty(
            UserProperty.DefaultSoldToNum,
            saveRequest.newSoldToNum
          );

          PublisherService.notifyAccountChange(response);

          AppUtilService.message.success(
            UserConstants.Messages.AccountChangeSuccessMessage
          );
          AppUtilService.redirectToHome();
        }
      });
  }
  onSignInClick(): void {
    PublisherService.notifySignInRequest(null);
  }

  onLogOffClick() {
    PublisherService.notifySignOutRequest();
  }

  onBillerDirectClick() {
    window.open(this.envProperties.billerDirectUrl, '_blank');
  }

  /***************Component Methods***************/

  /***************Private Methods***************/

  private onAuthenticationChange(authenticated: boolean) {
    this.authenticated = authenticated;
    if (this.authenticated) {
      this.getAccounts();
      this.loadDefaultAccount(); 
    }
  }

  private onAccountChange(accountChanged: any) {
    if (accountChanged) {
      this.loadDefaultAccount();
    }
  }

  private onCartCountUpdate(orderCount: any) {
    this.orderCount = orderCount;
  }

  private onUserSettingsChange() {
    this.loadDefaultAccount();
  }

  private loadDefaultAccount() {
    this.userDetail = AppUtilService.cache.get(CacheConstant.User_Auth_Detail);
    this.defaultAccount = this.userService.getDefaultAccountMasterData();
  }

routeClick(route){
 if(route==this.routes.fullCatalog){
      this.router.navigate([route], { queryParams: { catalog: 'product-catalog' }});
    }
    else{
    this.router.navigate([route]);
   }
  if(this.router.url=='/'+route ||this.router.url==route ||this.router.url=='/'+route +'?catalog=product-catalog' ){
    this.reload()
  }
}
reload(){
  window.location.reload();
}
getPromotion() {
    this.hasPromotions = false;
    this.userService.getPromotions(this.envProperties.buId).subscribe(res => {
      this.promotions = res;
      if (this.promotions.length) {
        this.hasPromotions = true;
        this.promotions.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));
      }
    });
  }
  getCategories() {

    this.hasCategories = false;
    this.productService.getCategories().subscribe(res => {
      this.categories = res;
      this.hasCategories = true;
    });

    
  } onPromotionClick(promotion: any) {
    if (this.config.gTrackingId) {
      this.gAnalytics.logPromotionClick(promotion);
    }
    //this.router.navigate([this.routes.promotionDetails + promotion.categoryId]);
  }
  openDialog(){
       const dialogRef:MatDialogRef<PurchaseHistoryComponent>  = this.dialog.open(PurchaseHistoryComponent, {
         data:'price changes alert',
       width: '100%',
       height:'600px'
     });
       dialogRef.afterClosed().subscribe(result => {
       });
    }
     onSearchChange() {
        if (this.searchProduct.value) {
          setTimeout(() => {
            this.searchProduct.value.replace(
              Regex.RestrictSpecialChars,
              ''
            );
          }, 50);
        }
      }

       onSearchProductSubmit() {
    let searchUrl = ProductRoutes.BasicSearch + '/';
    let advanceOption = null;
    let advanceOperand = null;

    if (this.search.isAdvance) {
      advanceOption = this.search.option.typeDesc.slugify();
      advanceOperand = this.search.operand.typeDesc.slugify();

      searchUrl =
        ProductRoutes.AdvanceSearch +
        '/' +
        advanceOption +
        '/' +
        advanceOperand +
        '/';
    }
    searchUrl =
      // searchUrl + (this.search.value ? this.search.value.encode() : '');
      searchUrl + (this.searchProduct.value ? this.searchProduct.value.encode() : '');
    if (this.config.gTrackingId) {
      this.gAnalytics.logSearch(this.searchProduct.value);
    }
    AppUtilService.router.navigate([searchUrl]);
if (this.router.url === '/' + searchUrl) {
      if (this.config.gTrackingId) {
        this.gAnalytics.logSearch(this.searchProduct.value);
      }
      PublisherService.notifySearchTrigger({
        // searchVal: this.search.value,
        searchVal: this.searchProduct.value,
        advSearchType: advanceOption,
        advSearchFilter: advanceOperand
      });
    }

    // this.search.value = '';
    this.searchProduct.setValue('');
  }
  /***************Private Methods***************/
}
